import { render, staticRenderFns } from "./feedbackReasonGroup.vue?vue&type=template&id=33343812&scoped=true&"
import script from "./feedbackReasonGroup.vue?vue&type=script&lang=js&"
export * from "./feedbackReasonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33343812",
  null
  
)

export default component.exports